var _rect, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.22656,
    y: 26.3193,
    width: 19.4356,
    height: 6.68098,
    rx: 3.34049,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4877,
    cy: 15.4877,
    r: 14.9877,
    fill: "#FF0079",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4994,
    cy: 17.4877,
    r: 14.9877,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12549 19.9849L9.3999 14.6016H10.1118L10.2744 15.498L8.9165 21H8.15186L8.12549 19.9849ZM7.4707 14.6016L8.52539 19.9849L8.4375 21H7.58496L6.16553 14.6016H7.4707ZM11.395 19.9629L12.4365 14.6016H13.7417L12.3267 21H11.4741L11.395 19.9629ZM10.5117 14.6016L11.7949 20.0068L11.7598 21H10.9951L9.62842 15.4937L9.8042 14.6016H10.5117ZM18.7515 19.9717V21H15.3457V19.9717H18.7515ZM15.7764 14.6016V21H14.458V14.6016H15.7764ZM18.3076 17.2075V18.2095H15.3457V17.2075H18.3076ZM18.7471 14.6016V15.6343H15.3457V14.6016H18.7471ZM22.4692 14.6016V21H21.1553V14.6016H22.4692ZM24.438 14.6016V15.6343H19.2173V14.6016H24.438ZM29.4565 17.2075V18.2358H26.1167V17.2075H29.4565ZM26.5078 14.6016V21H25.1895V14.6016H26.5078ZM30.397 14.6016V21H29.083V14.6016H30.397Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeth);
export default __webpack_public_path__ + "static/media/weth.8b5eab88b4aa76b8bfa3fe299380f36b.svg";
export { ForwardRef as ReactComponent };